import { render, staticRenderFns } from "./BrushTopic2.vue?vue&type=template&id=4934f0dc&scoped=true&"
import script from "./BrushTopic2.vue?vue&type=script&lang=js&"
export * from "./BrushTopic2.vue?vue&type=script&lang=js&"
import style0 from "./BrushTopic2.vue?vue&type=style&index=0&id=4934f0dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4934f0dc",
  null
  
)

export default component.exports